"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSignedOperation = exports.getCreatePayload = exports.getDidDocumentModel = void 0;
const func_1 = require("./func");
exports.getDidDocumentModel = (primaryPublicKey, recoveryPublicKey) => ({
    '@context': 'https://w3id.org/did/v1',
    publicKey: [
        {
            id: '#primary',
            usage: 'signing',
            type: 'Secp256k1VerificationKey2018',
            publicKeyHex: primaryPublicKey,
        },
        {
            id: '#recovery',
            usage: 'recovery',
            type: 'Secp256k1VerificationKey2018',
            publicKeyHex: recoveryPublicKey,
        },
    ],
});
exports.getCreatePayload = (didDocumentModel, primaryKey) => {
    // Create the encoded protected header.
    const header = {
        operation: 'create',
        kid: '#primary',
        alg: 'ES256K',
    };
    return exports.makeSignedOperation(header, didDocumentModel, primaryKey.privateKey);
};
exports.makeSignedOperation = (header, payload, privateKey) => {
    const encodedHeader = func_1.encodeJson(header);
    const encodedPayload = func_1.encodeJson(payload);
    const signature = func_1.signEncodedPayload(encodedHeader, encodedPayload, privateKey);
    return {
        protected: encodedHeader,
        payload: encodedPayload,
        signature,
    };
};
//# sourceMappingURL=op.js.map